import { useContext } from 'react';
import { MarkdownLinkPreviewContext } from './markdownLinkPreviewContext';
import type { LinkPreview } from '../utils/linkThumbnail';

/**
 * undefined — preview not resolved yet (or href absent)
 * null — resolved, no rich preview
 * LinkPreview — resolved thumbnail card
 */
export function useMarkdownLinkPreview(
  href: string | undefined
): LinkPreview | null | undefined {
  const cache = useContext(MarkdownLinkPreviewContext);
  if (!href) {
    return undefined;
  }
  return cache.get(href);
}
